import React from "react";
import { Link } from "react-router-dom";
import { colors, fonts } from "./theme";
import { contact, categories } from "./data";
import { PhoneLink, AddressLink } from "./ui";

const PAGES = [
  { to: "/", label: "Home" },
  { to: "/catalogue", label: "Catalogue" },
  { to: "/brands", label: "Brands" },
  { to: "/about", label: "About" },
  { to: "/faq", label: "FAQ" },
  { to: "/contact", label: "Contact" },
];

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      style={{
        borderTop: `1px solid ${colors.border}`,
        background: colors.panel,
      }}
    >
      <div
        className="se-footer"
        style={{
          maxWidth: "1180px",
          margin: "0 auto",
          // Was fixed at every width: 52px of top padding and 28px gutters are
          // desktop proportions, and on a 320px screen the gutters alone took
          // 17.5% of the line.
          padding: "clamp(36px,8vw,52px) var(--sp-gutter) clamp(28px,6vw,40px)",
          display: "grid",
          gridTemplateColumns: "1.4fr 1fr 1fr 1fr",
          gap: "40px",
        }}
      >
        <div>
          <div
            style={{
              fontFamily: fonts.serif,
              fontSize: "21px",
              fontWeight: 600,
            }}
          >
            Sigma Enterprises
          </div>
          <div
            style={{
              fontFamily: fonts.mono,
              fontSize: "var(--fs-tag)",
              letterSpacing: "0.24em",
              color: colors.brown,
              textTransform: "uppercase",
              marginTop: "4px",
            }}
          >
            Paper &amp; Board Distributor
          </div>
          <p
            style={{
              fontSize: "var(--fs-base)",
              color: colors.muted,
              lineHeight: 1.6,
              maxWidth: "36ch",
              margin: "16px 0 0",
            }}
          >
            Wholesale paper &amp; board distributor supplying the printing,
            packaging and publishing trade across India.
          </p>
        </div>

        <div>
          <div
            style={{
              fontFamily: fonts.mono,
              fontSize: "var(--fs-label)",
              letterSpacing: "0.14em",
              textTransform: "uppercase",
              color: colors.brown,
              marginBottom: "14px",
            }}
          >
            Pages
          </div>
          {/* .se-flinks blocks the anchors out to ~44px below 860px (see
              index.css). It hangs on the wrapper rather than the links because
              it also has to zero this gap — 10px of it plus 22px of new
              padding would be a 32px trough between every pair. */}
          <div
            className="se-flinks"
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "10px",
              fontSize: "var(--fs-base)",
              color: colors.muted,
            }}
          >
            {PAGES.map((p) => (
              <Link key={p.to} to={p.to} style={{ cursor: "pointer" }}>
                {p.label}
              </Link>
            ))}
          </div>
        </div>

        {/* Site-wide links into the category pages. These are the commercial
            pages we want ranking, and a footer link from every page is the
            cheapest internal-link equity available. */}
        <div>
          <div
            style={{
              fontFamily: fonts.mono,
              fontSize: "var(--fs-label)",
              letterSpacing: "0.14em",
              textTransform: "uppercase",
              color: colors.brown,
              marginBottom: "14px",
            }}
          >
            What we supply
          </div>
          <div
            className="se-flinks"
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "10px",
              fontSize: "var(--fs-base)",
              color: colors.muted,
            }}
          >
            {categories.map((c) => (
              <Link
                key={c.slug}
                to={`/catalogue/${c.slug}`}
                style={{ cursor: "pointer" }}
              >
                {c.name}
              </Link>
            ))}
          </div>
        </div>

        <div>
          <div
            style={{
              fontFamily: fonts.mono,
              fontSize: "var(--fs-label)",
              letterSpacing: "0.14em",
              textTransform: "uppercase",
              color: colors.brown,
              marginBottom: "14px",
            }}
          >
            Get in touch
          </div>
          {/* The phone number and the address are both <a> here now — a
              WhatsApp deep link and a Maps deep link respectively — so
              .se-flinks gives both the same 44px box as the two link columns. */}
          <div
            className="se-flinks"
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "10px",
              fontSize: "var(--fs-base)",
              color: colors.muted,
            }}
          >
            <PhoneLink style={{ fontFamily: fonts.mono }} />
            <AddressLink style={{ lineHeight: 1.6, cursor: "pointer" }}>
              B-33/13, Paper Market,
              <br />
              Ramesh Nagar, Raja Garden, New Delhi — 110015
            </AddressLink>
          </div>
        </div>
      </div>

      <div style={{ borderTop: `1px solid ${colors.border}` }}>
        <div
          style={{
            maxWidth: "1180px",
            margin: "0 auto",
            // Horizontal padding tracks the block above it so the two rows
            // share one gutter at every width.
            padding: "18px var(--sp-gutter)",
            display: "flex",
            justifyContent: "space-between",
            flexWrap: "wrap",
            gap: "8px",
            fontSize: "var(--fs-meta)",
            // muted3 was 2.22:1 against the panel this bar sits on — the worst
            // contrast on the site. See the note in theme.js for why nothing
            // lighter than `muted` can pass on that surface.
            color: colors.muted,
          }}
        >
          <span>© {year} Sigma Enterprises. All rights reserved.</span>
          <span style={{ fontFamily: fonts.mono }}>{contact.city}</span>
        </div>
      </div>
    </footer>
  );
}
